import { DISCORD_URL } from "@/lib/config";

const Hero = () => {
  return (
    <section id="hero" data-testid="hero-section" className="pt-16 pb-20 px-6 border-b border-red-500/20 relative overflow-hidden">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-center gap-2 font-mono-x text-xs text-[#ff4655] mb-4">
          <span className="w-2 h-2 bg-[#ff4655] blink-dot"></span>
          NEXT-GEN VISION AI FOR FPS GAMES
        </div>

        <h1 data-testid="hero-headline" className="font-display text-6xl md:text-9xl uppercase tracking-tighter leading-[0.9] text-white mb-8">
          High Precision.<br />
          <span className="text-[#ff4655]">Zero Latency.</span>
        </h1>

        <p data-testid="hero-subheadline" className="text-zinc-300 text-lg md:text-xl max-w-2xl mb-10 font-normal leading-relaxed">
          Extensively trained vision neural weights engineered for lightning response and flawless competitive accuracy.
        </p>

        <div className="flex flex-wrap gap-4 mb-16">
          <a
            href="#pricing"
            data-testid="hero-cta-pricing"
            className="px-8 py-4 bg-[#ff4655] hover:bg-white hover:text-black text-white font-extrabold uppercase text-xs tracking-widest transition-colors skew-x-[-8deg]"
          >
            <span className="inline-block skew-x-[8deg]">Unlock AI Models</span>
          </a>
          <a
            href={DISCORD_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="hero-cta-discord"
            className="px-8 py-4 bg-zinc-900 border border-zinc-700 hover:border-white text-white font-bold uppercase text-xs tracking-widest transition-colors skew-x-[-8deg]"
          >
            <span className="inline-block skew-x-[8deg]">Discord Checkout Flow</span>
          </a>
        </div>

        {/* Set-piece: detection scanner over arena visual */}
        <div
          data-testid="hero-vision-panel"
          className="hero-wipe rounded border border-red-500/30 bg-[#0c0d12] relative overflow-hidden aspect-[1301/771] flex flex-col justify-between"
        >
          <img
            src="/assets/vision-engine.png"
            alt="Scythe vision engine detecting in-game objects in real time"
            className="absolute inset-0 w-full h-full object-cover"
            loading="eager"
          />

          {/* scanning line */}
          <div className="scan-line absolute left-0 right-0 h-px bg-[#ff4655]/70 shadow-[0_0_12px_rgba(255,70,85,0.8)]"></div>

          <div className="relative flex justify-between items-center font-mono-x text-xs text-zinc-400 px-4 py-3 bg-gradient-to-b from-[#0c0d12]/80 to-transparent">
            <span className="text-[#ff4655] font-bold">SYSTEM // SCYTHE ENGINE ACTIVE</span>
            <span className="hidden sm:inline">CUDA / TENSOR-RT READY</span>
          </div>

          <div className="relative flex justify-between items-center font-mono-x text-[10px] text-zinc-400 px-4 py-3 border-t border-white/10 bg-gradient-to-t from-[#0c0d12]/80 to-transparent">
            <span>TENSOR INFERENCE: &lt; 1.0 MS</span>
            <span className="flex items-center gap-2">
              <span className="w-1.5 h-1.5 rounded-full bg-[#ff4655] blink-dot"></span>
              DISCORD RECEIPT VERIFIER: ONLINE
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
